var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.5H5.5625M10.25 8.375L12.125 6.5L10.25 4.625M7.125 3.375V2.75C7.125 2.41848 6.9933 2.10054 6.75888 1.86612C6.52446 1.6317 6.20652 1.5 5.875 1.5H2.75C2.41848 1.5 2.10054 1.6317 1.86612 1.86612C1.6317 2.10054 1.5 2.41848 1.5 2.75V10.25C1.5 10.5815 1.6317 10.8995 1.86612 11.1339C2.10054 11.3683 2.41848 11.5 2.75 11.5H5.875C6.20652 11.5 6.52446 11.3683 6.75888 11.1339C6.9933 10.8995 7.125 10.5815 7.125 10.25V9.625",
    stroke: "#0F0F0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.06e9b27b0f04a47e00c1bbb606d61c2f.svg";
export { ForwardRef as ReactComponent };